import React from 'react'
import SattaLayout from '../SattaCard/SattaLayout'
import ResultCardData from '../ResultCard/ResultCardData'
import RecordTableData from '../RecordTable/RecordTableData'
import SattaInfoBox from './SattaInfoBox'

const Home = () => {
  return (
    <div>
      <SattaLayout/>
      <ResultCardData/>
      {/* <RecordTableData/> */}
      <SattaInfoBox/>
    </div>
  )
}

export default Home
